<template>
  <svg
    aria-hidden="true"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke-linecap="round"
    stroke-linejoin="round"
    stroke="currentColor"
    stroke-width="1"
    ...attributes
  >
    <polyline points="18 15 12 9 6 15"></polyline>
  </svg>
</template>
